import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Button, Icon, Paragraph } from 'components/patterns'

export const TitleWrapper = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 5px;
  min-width: 0;
  overflow: hidden;
`

export const Title = styled.span`
  display: flex;
  flex-direction: row;
  min-width: 0;
  overflow: hidden;
  svg {
    margin-right: 10px;
    flex-shrink: 0;
  }
  h3 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const ContentWrapper = styled.span`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: ${themeColor('blackSecondary')};
`

export const CollectionMeta = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  font-size: 20px;
  margin-bottom: 10px;
`
export const PartNumber = styled(Paragraph)`
  font-weight: bold;
  color: ${themeColor('blackSecondary')};
  margin-right: 5px;
`

export const Author = styled(Paragraph)`
  margin-right: 6px;
  font-size: 12px;
  color: ${themeColor('blackSecondary')};
`

export const TimeStamp = styled(Paragraph)`
  margin-right: 3px;
  font-size: 10px;
  color: ${themeColor('greyPrimary')};
`

export const StyledCard = styled.div((props) => {
  const { isCompatible } = props
  return `
    min-height: 210px;
    padding: 20px;
    background-color: ${
      isCompatible
        ? themeColor('whitePrimary', props)
        : themeColor('offWhite', props)
    };
    border: 1px solid ${themeColor('grey', props)};
    border-bottom: 2px solid ${themeColor('grey', props)};
    width: 48%;
    margin: 0;
    display: flex;
    flex-direction: column;
    position: relative;
  `
})

export const ViewCollectionButtonWrapper = styled.div`
  text-align: right;
  width: 100%;
  position: absolute;
  bottom: 15px;
  left: -25px;
`

export const ViewCollectionButton = styled(Button)`
  && {
    background-color: ${themeColor('bluePrimary')};
    color: ${themeColor('whitePrimary')};
    border-color: ${themeColor('bluePrimary')};

    &:hover {
      background-color: ${themeColor('blueSecondary')};
      border-color: ${themeColor('blueSecondary')};
    }

    span {
      display: inline;
      line-height: 18px;
      vertical-align: middle;
    }
  }
`

export const CollectionIcon = styled(Icon)`
  & path {
    fill: ${themeColor('bluePrimary')} !important;
    fill-rule: evenodd;
    clip-rule: evenodd;
  }
`

/**
 * PBI 150666: Status text for collection cards
 * Shows the lifecycle status as plain text aligned to the right
 * Figma style: Paragraph/Large/Regu
 */
export const StatusText = styled.span`
  color: ${themeColor('blackSecondary')};
  text-align: right;
  font-family: Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`

/**
 * WP-5: Vehicle Type & QuickFit Sales Code line
 */
export const VehicleTypeRow = styled.div`
  font-size: 12px;
  color: ${themeColor('blackSecondary')};
  white-space: nowrap;
  margin-left: 10px;
`

/**
 * WP-5: ECU Inventory & App Variants line (right-justified)
 */
export const EcuVariantRow = styled.div`
  font-size: 12px;
  color: ${themeColor('blackSecondary')};
  text-align: right;
  margin-bottom: 2px;
`

/**
 * WP-5: Collection Number, bold 14px
 */
export const CollectionNumber = styled.span`
  font-weight: bold;
  font-size: 14px;
  color: ${themeColor('blackPrimary')};
  margin-right: 4px;
`

/**
 * WP-5: Row that holds collection number and potentially a legacy warning icon
 */
export const CollectionNumberRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`

/**
 * WP-5: Legacy warning triangle icon (grey)
 */
export const LegacyWarningIcon = styled(Icon)`
  margin-left: 6px;
  & path {
    fill: ${themeColor('slateLight')} !important;
  }
`

/**
 * WP-5: Row that holds vehicle type on left and ECU variant on right
 */
export const CardMetaRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 2px;
`
